// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"0d740aa0a359605d9a48","883":"130edbf8435990b5e60c"}[chunkId] + ".js";
};